export interface SeasonObj {
	seasonId: string;
	slug: string;
	title: string;
}

export interface SeasonStrapi {
	data: {
		attributes: SeasonObj;
	};
}

enum Season {
	SUMMER = "summer",
	ACADEMIC_YEAR = "academic-year",
}

export default Season;

export const SeasonNames = {
	[Season.SUMMER]: "Summer",
	[Season.ACADEMIC_YEAR]: "Academic Year",
};
